import { render, staticRenderFns } from "./OBooleanButton.vue?vue&type=template&id=37cb55b8&scoped=true&"
import script from "./OBooleanButton.vue?vue&type=script&lang=js&"
export * from "./OBooleanButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb55b8",
  null
  
)

export default component.exports